import styled from 'styled-components';

import OperationsNavigation from '../operation-navigation/OperationNavigation';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${theme.colors.interactive.brandColor} 0%, #143987 100%)`};
  padding: 1.6rem 0.8rem 0.8rem;
  height: fit-content;
  width: 100%;
  ${({ theme }) => theme.media.laptop`
    width:unset;
`};
`;

export const ContentContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.default};
  margin-top: 1.6rem;
`;

export const ContentBalancesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 2rem 1.6rem 1.6rem;
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

export const BalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TabsWrapper = styled.div`
  max-width: 10.4rem;
  width: 100%;
`;

export const Separator = styled.div`
  width: 100%;
  margin: 1.6rem 0;

  height: 1px;

  background-color: ${({ theme }) => theme.colors.borders.default};
`;

export const TitleWrapper = styled.div`
  margin-left: 0.8rem;
`;

export const OperationsWrapper = styled.div`
  display: none;
  ${({ theme }) => theme.media.laptop`
    display: block;
  `};
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 0.4rem;
  align-items: center;
  gap: 0.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background: ${({ theme }) => theme.colors.surface.default};
`;

export const CustomOperationsNavigation = styled(OperationsNavigation)`
  ${({ theme }) => theme.media.laptop`
      padding:0 1.6rem;
      .nav-item-wrapper{
        padding: 1.6rem 0;
      }
  `}
`;
